export const deg = (d) => (d * Math.PI) / 180;

export const setX = (bone, val) => {
    if (bone) bone.rotation.x = val;
};

export const setY = (bone, val) => {
    if (bone) bone.rotation.y = val;
};

/**
 * Setup bones + default pose
 * @param {THREE.Object3D} model
 * @param {Object} ref
 * @param {string} prefix (e.g. "Arjun", "Ananya")
 */
export const setupStudentBones = (model, ref, prefix) => {
    const bones = {};

    // 🔍 collect bones
    model.traverse((obj) => {
        if (obj.isBone) bones[obj.name] = obj;
    });

    ref.model = model;

    /* ---------- SPINE (if exists) ---------- */
    if ("spine01" in ref) {
        ref.spine01 = bones[`${prefix}Spine01`];
        ref.spine02 = bones[`${prefix}Spine02`];

        ref.spine01Original = ref.spine01?.rotation.x || 0;
        ref.spine02Original = ref.spine02?.rotation.x || 0;
    }

    /* ---------- ARMS ---------- */
    ref.rightArm = bones[`${prefix}RightArm`];
    ref.rightForearm = bones[`${prefix}RightForearm`];
    ref.leftArm = bones[`${prefix}LeftArm`];
    ref.leftForearm = bones[`${prefix}LeftForearm`];

    /* ---------- HAND END ---------- */
    ref.rightHandEnd = bones[`${prefix}RightHand_End`];
    ref.leftHandEnd = bones[`${prefix}LeftHand_End`];

    /* ---------- LEGS ---------- */
    ref.leftThigh = bones[`${prefix}LeftThigh`];
    ref.rightThigh = bones[`${prefix}RightThigh`];
    ref.leftShin = bones[`${prefix}LeftShin`];
    ref.rightShin = bones[`${prefix}RightShin`];

    /* ---------- STORE STAND POSE ---------- */
    ref.standLeftThigh = ref.leftThigh?.rotation.x || 0;
    ref.standRightThigh = ref.rightThigh?.rotation.x || 0;
    ref.standLeftShin = ref.leftShin?.rotation.x || 0;
    ref.standRightShin = ref.rightShin?.rotation.x || 0;

    /* ---------- DEFAULT SITTING POSE ---------- */
    const thigh = Math.PI * 0.5;
    const shin = Math.PI * 0.5;

    setX(ref.leftThigh, thigh);
    setX(ref.rightThigh, thigh);
    setX(ref.leftShin, shin);
    setX(ref.rightShin, shin);

    ref.sitThigh = thigh;
    ref.sitShin = shin;

    if ("isSitting" in ref) {
        ref.isSitting = true;
    }

    /* ---------- DEFAULT ARM POSE ---------- */
    const shoulderY = deg(5);
    const forearmX = deg(30);

    setY(bones[`${prefix}RightShoulder`], shoulderY);
    setY(bones[`${prefix}LeftShoulder`], -shoulderY);

    setX(ref.leftArm, deg(5));
    setX(ref.rightArm, deg(15));
    setX(ref.leftForearm, forearmX);
    setX(ref.rightForearm, forearmX);
};